import { hmacSha256, sha256 } from "./crypto.js";
import { RainEvent } from "./schemas/chat.js";
export async function selectRainWinners(serverSeed, clientSeed, id, candidates, count) {
    const scores = await Promise.all(candidates.map(async (participant) => ({
        participant,
        score: await hmacSha256(serverSeed, JSON.stringify(["crashx-rain-v1", id, clientSeed, participant])),
    })));
    return scores
        .sort((a, b) => (a.score < b.score ? -1 : a.score > b.score ? 1 : a.participant < b.participant ? -1 : 1))
        .slice(0, count)
        .map((row) => row.participant);
}
export async function rainCommitment(serverSeed, id, amount, recipients, candidates) {
    return sha256(JSON.stringify(["crashx-rain-v1", serverSeed, id, amount, recipients, candidates]));
}
export async function verifyRain(raw) {
    const result = RainEvent.safeParse(raw);
    if (!result.success)
        return false;
    const event = result.data;
    if (new Set(event.candidates).size !== event.candidates.length ||
        event.candidates.length < event.recipients ||
        event.winners.length !== event.recipients)
        return false;
    if ((await rainCommitment(event.serverSeed, event.id, event.amount, event.recipients, event.candidates)) !==
        event.commitment)
        return false;
    const winners = await selectRainWinners(event.serverSeed, event.clientSeed, event.id, event.candidates, event.recipients);
    // Verification uses integer cents; ledger accounting remains Decimal on the server.
    const cents = (value) => {
        const [whole, part = ""] = value.split(".");
        return BigInt(whole) * 100n + BigInt(part.padEnd(2, "0"));
    };
    const total = cents(event.amount);
    const count = BigInt(event.recipients);
    if (total < count)
        return false;
    return event.winners.every((winner, index) => winner.participant === winners[index] &&
        cents(winner.amount) === total / count + (BigInt(index) < total % count ? 1n : 0n));
}
//# sourceMappingURL=rain-proof.js.map